<template>
  <span class="header-search">
    <a-icon type="user" class="search-icon" />
    <span class="info"
      >欢迎您
      <a-dropdown placement="bottomRight">
        <span style="user-select: none">{{ siteInfo.truename }}</span>
        <a-menu slot="overlay" style="width: 200px;">
          <a-menu-item key="1" disabled
            >账号：{{ siteInfo.loginname }}</a-menu-item
          >
          <a-menu-item key="2" disabled>权限：{{ siteInfo.role }}</a-menu-item>
          <a-menu-item key="3" style="text-align: right;">
            <a-button
              type="primary"
              icon="poweroff"
              size="small"
              @click="logout()"
              >退出系统</a-button
            >
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </span>
    <span @click="switchSite">
      站点切换<a-icon type="desktop" class="search-icon" />
    </span>
    <a-drawer
      title="站点切换"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="visible"
    >
      <a-card>
        <a-card-grid
          class="lists"
          v-for="(item, index) in siteLists"
          :class="{ active: siteInfo.site_id == item.siteid }"
          @mouseover="hover(index)"
          @mouseleave="hover(-1)"
          @click="changeSite(index)"
          :key="index"
        >
          <a-icon type="double-right" v-if="hoverIndex == index" />
          {{ item.sitename }}
        </a-card-grid>
      </a-card>
      <!--      <p v-for="(item,index) in siteLists">{{item.sitename}}</p>-->
    </a-drawer>
    <!--    <a-auto-complete-->
    <!--      ref="input"-->
    <!--      :dataSource="dataSource"-->
    <!--      :class="['search-input', searchMode ? 'enter' : 'leave']"-->
    <!--      placeholder="站内搜索"-->
    <!--      @blur="leaveSearchMode"-->
    <!--    >-->
    <!--    </a-auto-complete>-->
  </span>
</template>

<script>
export default {
  name: 'HeaderSearch',
  data() {
    return {
      dataSource: ['选项一', '选项二'],
      searchMode: false,
      siteInfo: {},
      siteLists: [],
      visible: false,
      hoverIndex: -1
    };
  },
  created() {
    this.getSiteInfo();
    this.getSiteLists();
  },
  methods: {
    changeSite(index) {
      let that = this;
      this.$confirm({
        title: '确认切换站点',
        content:
          '您将切换至"' + this.siteLists[index].sitename + '" 站点，请确认',
        onOk() {
          that.goSite(index);
        },
        onCancel() {}
      });
    },
    goSite(index) {
      this.$http
        .post('/api/ucenter/changesite', {
          siteid: this.siteLists[index].siteid
        })
        .then(res => {
          if (res.data.state == 200) {
            this.siteInfo.site_id = this.siteLists[index].siteid;
            window.localStorage.setItem(
              'siteinfo',
              JSON.stringify(this.siteInfo)
            );
            this.$message
              .success('切换成功，正在准备数据', 2.5)
              .then(() => location.reload());
          }
        });
    },
    hover(index) {
      this.hoverIndex = index;
    },
    switchSite() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    getSiteLists() {
      this.$http.get('/api/content/sitelist').then(res => {
        if (res.data.state == 200) {
          this.siteLists = res.data.data;
          localStorage.setItem('siteLists', JSON.stringify(this.siteLists));
        }
      });
    },
    logout() {
      this.$confirm({
        title: '退出确认',
        content: '确定要退出本系统吗？',
        onOk() {
          window.localStorage.clear();
          window.location.href = 'https://uc.ycrmt.cn/index.php/login/index';
        },
        onCancel() {}
      });
    },
    getSiteInfo() {
      let siteInfo = JSON.parse(window.localStorage.getItem('siteinfo'));
      this.siteInfo = siteInfo;
    },
    enterSearchMode() {
      this.searchMode = true;
      setTimeout(() => this.$refs.input.focus(), 300);
    },
    leaveSearchMode() {
      this.searchMode = false;
    }
  }
};
</script>

<style lang="less">
span .info {
  display: inline-block;
  line-height: 50px;
  margin-right: 10px;
}
.header-search {
  .search-icon {
    font-size: 16px;
    cursor: pointer;
    height: 50px;
    line-height: 50px;
    margin: 0 5px;
  }
  .search-input {
    border: 0;
    border-bottom: 1px rgba(3, 5, 6, 0.23) solid;
    transition: width 0.3s ease-in-out;
    input {
      border: 0;
      box-shadow: 0 0 0 0;
    }
    &.leave {
      width: 0px;
      input {
        display: none;
      }
    }
    &.enter {
      width: 200px;
      input:focus {
        box-shadow: 0 0 0 0;
      }
    }
  }
}
</style>
<style scoped>
.lists {
  width: 100%;
  height: 60px;
  line-height: 60px;
  padding-left: 20px;
  font-size: 16px;
}
.active {
  color: #fff;
  background: #1890ff;
}
</style>
